import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import Select from 'react-select';
import moment from 'moment';
import * as c from '../constant';
import * as actions from '../actions';

function UpdateBilling({
  id,
  type,
  updateBilling,
  updatingBilling,
  getItem,
  getBillingList,
  billingList,
}) {
  const [formData, setFormData] = useState({
    billing_id: '',
  });
  const setModal = useContext(ModalContext);

  const formatPeriod = data => {
    let val = '';
    switch (data) {
      case 0:
        val = '1st Quarter';
        break;
      case 1:
        val = '1st Quarter';
        break;
      case 2:
        val = '2nd Quarter';
        break;
      case 3:
        val = '3rd Quarter';
        break;
      case 4:
        val = '4th Quarter';
        break;
      default:
        val = '';
        break;
    }
    return val;
  };

  useEffect(() => {
    getBillingList(id);
  }, []);

  const handleOnSubmit = e => {
    e.preventDefault();

    updateBilling(id, formData, () => {
      setModal({ isOpen: false });
      getItem(id);
    });
  };

  const handleDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const extraBillingDetail = (item, data) => {
    if(item === "QUARTERLY"){
      return ` | ${formatPeriod(_.get(data, 'attributes.qtr_from'))} to ${formatPeriod(_.get(data, 'attributes.qtr_to'))}`
    }
    if(item === "DELINQUENT"){
      return ` | ${_.get(data, 'attributes.year')}`
    }
    return ""
  }

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const selectBillingOption = billingList.map(x => ({
    label: `${_.get(x, 'attributes.e_soa_no')} | ${`${moment(
      _.get(x, 'attributes.billing_date')
    ).format('MM-DD-YYYY')}`} | ${'\u20B1'} ${_.get(
      x,
      'attributes.total_human'
    )}${extraBillingDetail(type, x)}`,
    value: x.id,
    id: x.id,
  }));

  const findBillingValue =
    selectBillingOption.find(
      item => +_.get(formData, 'billing_id') === +item.id
    ) || '';

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            Are you sure, do you want update billing for this application?
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label mb-0">
              Select Billing
            </label>
            <Select
              options={selectBillingOption}
              onChange={handleDropDownChange('billing_id')}
              value={findBillingValue}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   "
            disabled={updatingBilling}
          >
            <span className="font-weight-bold">
              {/* eslint-disable */}
              {updatingBilling ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                `Submit`
              )}
            </span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateBilling.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,
  getBillingList: PropTypes.instanceOf(Function).isRequired,
  billingList: PropTypes.instanceOf(Object).isRequired,
  updateBilling: PropTypes.instanceOf(Function).isRequired,
  updatingBilling: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  billingList: _.get(api, `${c.GET_BILLING_LIST}.list`) || [],
  updatingBilling: api.loading.indexOf(c.UPDATE_BILLING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateBilling);
